export default "__VITE_ASSET__575c48b1__"